import { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const meses = [
  { num: 1, label: 'Janeiro' }, { num: 2, label: 'Fevereiro' }, { num: 3, label: 'Março' },
  { num: 4, label: 'Abril' }, { num: 5, label: 'Maio' }, { num: 6, label: 'Junho' },
  { num: 7, label: 'Julho' }, { num: 8, label: 'Agosto' }, { num: 9, label: 'Setembro' },
  { num: 10, label: 'Outubro' }, { num: 11, label: 'Novembro' }, { num: 12, label: 'Dezembro' },
];

function Financeiro() {
  const mesAtual = new Date().getMonth() + 1;
  const anoAtual = new Date().getFullYear();
  const [mesSelecionado, setMesSelecionado] = useState(mesAtual);
  const [anoSelecionado, setAnoSelecionado] = useState(anoAtual);
  const [clientes, setClientes] = useState([]);
  const [pagamentos, setPagamentos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [novoCliente, setNovoCliente] = useState({ nome: '', valor: '', vencimento: '' });
  const [editando, setEditando] = useState(null); // { id, campo, valor }

  const formatarMoeda = (valor) => Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  useEffect(() => { buscarClientes(); }, []);

  useEffect(() => {
      if (clientes.length > 0) {
        buscarPagamentos();
        buscarDespesas();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mesSelecionado, anoSelecionado, clientes]);

  const buscarClientes = async () => {
    const { data, error } = await supabase.from('clientes').select('*').eq('ativo', true);
    if (!error) setClientes(data);
    setCarregando(false);
  };

  const buscarDespesas = async () => {
    const { data } = await supabase.from('despesas')
      .select('valor')
      .eq('mes', String(mesSelecionado))
      .eq('ano', String(anoSelecionado));
    const total = (data || []).reduce((acc, d) => acc + Number(d.valor), 0);
    setTotalPagar(total);
  };

  const buscarPagamentos = async () => {
    const { data, error } = await supabase.from('pagamentos').select('*')
      .eq('mes', String(mesSelecionado)).eq('ano', String(anoSelecionado));
    if (!error) setPagamentos(data || []);
  };

  const isPago = (clienteId) => pagamentos.some(p => p.cliente_id === clienteId && p.pago);

  const getCobranca = (clienteId) => {
    const p = pagamentos.find(p => p.cliente_id === clienteId);
    return p?.status_cobranca || 'pendente';
  };

  const togglePago = async (clienteId) => {
    const pagamentoExistente = pagamentos.find(p => p.cliente_id === clienteId);
    if (pagamentoExistente) {
      await supabase.from('pagamentos').update({ pago: !pagamentoExistente.pago }).eq('id', pagamentoExistente.id);
    } else {
      await supabase.from('pagamentos').insert({ cliente_id: clienteId, mes: String(mesSelecionado), ano: String(anoSelecionado), pago: true });
    }
    buscarPagamentos();
  };

  const toggleCobranca = async (clienteId) => {
    const pagamentoExistente = pagamentos.find(p => p.cliente_id === clienteId);
    const novoStatus = getCobranca(clienteId) === 'cobrado' ? 'pendente' : 'cobrado';
    if (pagamentoExistente) {
      await supabase.from('pagamentos').update({ status_cobranca: novoStatus }).eq('id', pagamentoExistente.id);
    } else {
      await supabase.from('pagamentos').insert({ cliente_id: clienteId, mes: String(mesSelecionado), ano: String(anoSelecionado), pago: false, status_cobranca: novoStatus });
    }
    buscarPagamentos();
  };

  const salvarEdicao = async () => {
    if (!editando) return;
    const valor = editando.campo === 'valor' ? parseFloat(editando.valor)
      : editando.campo === 'vencimento' ? parseInt(editando.valor)
      : editando.valor;
    await supabase.from('clientes').update({ [editando.campo]: valor }).eq('id', editando.id);
    setEditando(null);
    buscarClientes();
  };

  const adicionarCliente = async () => {
    if (!novoCliente.nome || !novoCliente.valor || !novoCliente.vencimento) return;
    await supabase.from('clientes').insert({
      nome: novoCliente.nome, valor: parseFloat(novoCliente.valor), vencimento: parseInt(novoCliente.vencimento),
    });
    buscarClientes();
    setNovoCliente({ nome: '', valor: '', vencimento: '' });
    setMostrarForm(false);
  };

  const removerCliente = async (id) => {
    await supabase.from('clientes').update({ ativo: false }).eq('id', id);
    buscarClientes();
  };

  const totalReceber = clientes.reduce((acc, c) => acc + Number(c.valor), 0);
  const totalRecebido = clientes.filter(c => isPago(c.id)).reduce((acc, c) => acc + Number(c.valor), 0);
  const [totalPagar, setTotalPagar] = useState(0);
  const lucroPrevisto = totalReceber - totalPagar;

  const CelulaEditavel = ({ cliente, campo, display }) => {
    const estaEditando = editando?.id === cliente.id && editando?.campo === campo;
    return (
      <td className="p-4">
        {estaEditando ? (
          <div className="flex items-center gap-2">
            <input
              autoFocus
              type={campo === 'nome' ? 'text' : 'number'}
              value={editando.valor}
              onChange={(e) => setEditando({ ...editando, valor: e.target.value })}
              onKeyDown={(e) => { if (e.key === 'Enter') salvarEdicao(); if (e.key === 'Escape') setEditando(null); }}
              className="bg-gray-700 text-white rounded px-2 py-1 text-sm border border-blue-500 outline-none w-32"
            />
            <button onClick={salvarEdicao} className="text-green-400 hover:text-green-300 text-xs">✓</button>
            <button onClick={() => setEditando(null)} className="text-gray-400 hover:text-gray-300 text-xs">✕</button>
          </div>
        ) : (
          <div className="flex items-center gap-2 group">
            <span className={campo === 'nome' ? 'text-white' : 'text-gray-300'}>{display}</span>
            <button
              onClick={() => setEditando({ id: cliente.id, campo, valor: String(cliente[campo]) })}
              className="opacity-0 group-hover:opacity-100 text-gray-500 hover:text-blue-400 transition-all text-xs"
            >
              ✏️
            </button>
          </div>
        )}
      </td>
    );
  };

  if (carregando) return <div className="flex items-center justify-center h-64"><p className="text-gray-400">Carregando...</p></div>;

  return (
    <div>
      <div className="mb-8 flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-white">Financeiro</h2>
          <p className="text-gray-400 mt-1">Visão geral — {meses.find(m => m.num === mesSelecionado)?.label} {anoSelecionado}</p>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex gap-2">
            {[2025, 2026, 2027].map((ano) => (
              <button key={ano} onClick={() => setAnoSelecionado(ano)}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${anoSelecionado === ano ? 'bg-blue-600 text-white' : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'}`}>
                {ano}
              </button>
            ))}
          </div>
          <div className="flex gap-2 flex-wrap justify-end">
            {meses.map((mes) => (
              <button key={mes.num} onClick={() => setMesSelecionado(mes.num)}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${mesSelecionado === mes.num ? 'bg-blue-600 text-white' : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'}`}>
                {mes.label.slice(0, 3)}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4 mb-8">
        {[
          { label: 'A Receber', valor: totalReceber, cor: 'text-white' },
          { label: 'Recebido', valor: totalRecebido, cor: 'text-green-400' },
          { label: 'A Pagar', valor: totalPagar, cor: 'text-red-400' },
          { label: 'Lucro Previsto', valor: lucroPrevisto, cor: 'text-blue-400' },
        ].map(({ label, valor, cor }) => (
          <div key={label} className="bg-gray-900 rounded-xl p-6 border border-gray-800">
            <p className="text-gray-400 text-sm">{label}</p>
            <p className={`text-2xl font-bold mt-2 ${cor}`}>{formatarMoeda(valor)}</p>
          </div>
        ))}
      </div>

      <div className="bg-gray-900 rounded-xl border border-gray-800">
        <div className="p-6 border-b border-gray-800 flex justify-between items-center">
          <div>
            <h3 className="text-lg font-semibold text-white">Receitas — Clientes</h3>
            <span className="text-sm text-gray-400">{clientes.filter(c => isPago(c.id)).length}/{clientes.length} pagos</span>
          </div>
          <button onClick={() => setMostrarForm(!mostrarForm)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors">
            + Novo Cliente
          </button>
        </div>

        {mostrarForm && (
          <div className="p-6 border-b border-gray-800 bg-gray-800/50 flex gap-4 items-end">
            {[
              { label: 'Nome', key: 'nome', type: 'text', placeholder: 'Nome do cliente', width: '' },
              { label: 'Valor (R$)', key: 'valor', type: 'number', placeholder: '0,00', width: 'w-32' },
              { label: 'Vencimento (dia)', key: 'vencimento', type: 'number', placeholder: '10', width: 'w-24' },
            ].map(({ label, key, type, placeholder, width }) => (
              <div key={key} className="flex flex-col gap-1">
                <label className="text-xs text-gray-400">{label}</label>
                <input type={type} placeholder={placeholder} value={novoCliente[key]}
                  onChange={(e) => setNovoCliente({ ...novoCliente, [key]: e.target.value })}
                  className={`bg-gray-700 text-white rounded-lg px-3 py-2 text-sm outline-none border border-gray-600 focus:border-blue-500 ${width}`} />
              </div>
            ))}
            <button onClick={adicionarCliente} className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700">Salvar</button>
            <button onClick={() => setMostrarForm(false)} className="px-4 py-2 bg-gray-700 text-gray-300 rounded-lg text-sm font-medium hover:bg-gray-600">Cancelar</button>
          </div>
        )}

        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-800">
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Cliente</th>
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Valor</th>
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Vencimento</th>
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Status</th>
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Cobrança</th>
              <th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {clientes.map((cliente) => (
              <tr key={cliente.id} className="border-b border-gray-800 hover:bg-gray-800/50 transition-colors">
                <CelulaEditavel cliente={cliente} campo="nome" display={cliente.nome} />
                <CelulaEditavel cliente={cliente} campo="valor" display={formatarMoeda(Number(cliente.valor))} />
                <CelulaEditavel cliente={cliente} campo="vencimento" display={`Dia ${cliente.vencimento}`} />
                <td className="p-4">
                  <button onClick={() => togglePago(cliente.id)}
                    className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${isPago(cliente.id) ? 'bg-green-500/20 text-green-400 hover:bg-green-500/30' : 'bg-red-500/20 text-red-400 hover:bg-red-500/30'}`}>
                    {isPago(cliente.id) ? 'Pago' : 'Não Pago'}
                  </button>
                </td>
                <td className="p-4">
                  <button onClick={() => toggleCobranca(cliente.id)}
                    className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${getCobranca(cliente.id) === 'cobrado' ? 'bg-blue-500/20 text-blue-400 hover:bg-blue-500/30' : 'bg-yellow-500/20 text-yellow-400 hover:bg-yellow-500/30'}`}>
                    {getCobranca(cliente.id) === 'cobrado' ? 'Cobrança Feita' : 'Fazer Cobrança'}
                  </button>
                </td>
                <td className="p-4">
                  <button onClick={() => removerCliente(cliente.id)}
                    className="text-gray-600 hover:text-red-400 transition-colors text-sm">×</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Financeiro;